import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer } from '../utils/constants';
export function Experience() {
  const cases = [{
    title: 'Fraude Corporativo',
    desc: 'Defensa exitosa en caso de fraude corporativo por $2.5M, logrando la absolución total de los directivos implicados.',
    metric: '$2.5M',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80'
  }, {
    title: 'Propiedad Intelectual',
    desc: 'Resolución favorable en disputa de patentes para empresa tecnológica multinacional, asegurando derechos exclusivos.',
    metric: '100%',
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80'
  }];
  return <section id="experiencia" className="py-32 bg-grayLightest relative" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-57">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-58">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16" data-id="element-59">
            <motion.div variants={fadeUp} className="lg:col-span-1" data-id="element-60">
              <div className="sticky top-32" data-id="element-61">
                <h2 className="heading-brutalist text-4xl md:text-5xl mb-6 text-grayDarkest" data-id="element-62">
                  TRAYECTORIA Y RESULTADOS
                </h2>
                <p className="text-grayDarkest font-light text-lg mb-8" data-id="element-63">
                  Nuestra experiencia se mide en los resultados tangibles que
                  obtenemos para nuestros clientes en los escenarios más
                  complejos.
                </p>
                <div className="flex gap-4" data-id="element-64">
                  <div className="w-16 h-16 border border-grayDarkest flex items-center justify-center" data-id="element-65">
                    <div className="w-8 h-8 border border-grayMid" data-id="element-66"></div>
                  </div>
                </div>
              </div>
            </motion.div>

            <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-67">
              {cases.map((item, index) => <motion.div key={index} variants={fadeUp} className="bg-white border border-grayMid hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group flex flex-col" data-id="element-68">
                  <div className="h-48 w-full overflow-hidden relative" data-id="element-69">
                    <div className="absolute inset-0 bg-grayDarkest/40 z-10" data-id="element-70"></div>
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-71" />
                    <div className="absolute top-4 right-4 z-20 text-4xl font-montserrat font-bold text-white opacity-90" data-id="element-72">
                      {item.metric}
                    </div>
                  </div>
                  <div className="p-8 flex-1" data-id="element-73">
                    <h3 className="font-montserrat text-xl font-bold mb-4 text-grayDarkest uppercase tracking-wide" data-id="element-74">
                      {item.title}
                    </h3>
                    <p className="text-grayDarkest font-light leading-relaxed" data-id="element-75">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}